if (!customElements.get('variants-group')) {
  class VariantsGroup extends HTMLElement {
    /**
     * Properties.
     */
    selectors = {
      collection: 'variants-collection',
      showAllBtn: '[data-variants-show-all]',
      product: 'product-variant',
      meta: '[data-variants-meta]',
      hidden: '.hidden',
    };

    classes = {
      opened: 'is-opened',
    };

    attrs = {
      compareSection: 'data-variants-compare-section',
    };

    /**
     * constructor.
     */
    constructor() {
      super();
    }

    /**
     * connectedCallback.
     */
    connectedCallback() {
      this.collection = this.closest(this.selectors.collection);
      this.showAllBtn = this.querySelector(this.selectors.showAllBtn);
      this.products = this.querySelectorAll(this.selectors.product);
      this.maxCompareCount = parseInt(
        this.collection.dataset.maxCompareCount || 0,
      );
      this.meta = this.querySelector(this.selectors.meta);

      this.attachListeners();
    }

    /**
     * attachListeners.
     */
    attachListeners() {
      this.showAllBtn?.addEventListener(
        'click',
        this.showAllElements.bind(this),
      );
    }

    /**
     * showAllElements.
     * @param {Event} e
     */
    showAllElements(e) {
      e.preventDefault();

      const isOpen = this.classList.contains(this.classes.opened);
      const textMore = this.showAllBtn.dataset.textMore;
      const textLess = this.showAllBtn.dataset.textLess;

      const hiddenProducts = this.querySelectorAll(
        this.selectors.product.concat(this.selectors.hidden),
      );

      this.classList.toggle(this.classes.opened, !isOpen);
      this.showAllBtn.classList.toggle('button--outlined', !isOpen);
      isOpen
        ? (this.showAllBtn.innerText = textMore)
        : (this.showAllBtn.innerText = textLess);

      if (isOpen) {
        this.products.forEach((product, index) => {
          if (index + 1 > this.maxCompareCount) {
            product.classList.add('hidden');
          }
        });

        this.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      } else {
        hiddenProducts.forEach((product) => {
          product.classList.remove('hidden');
        });
      }

      // When we're showing all elements in compare section, we must respect the filters
      const isCompareGroup = this.hasAttribute(this.attrs.compareSection);
      if (isCompareGroup) {
        const event = new CustomEvent('filter-colors');
        this.collection.dispatchEvent(event);
      }

      this.renderMeta();
    }

    /**
     * hideElements.
     */
    hideElements(force = false) {
      const isSectionOpened = this.classList.contains(this.classes.opened);

      if (isSectionOpened && !force) return;

      this.products.forEach((product, index) => {
        if (index + 1 > this.maxCompareCount) {
          product.classList.add('hidden');
        }
      });
    }

    /**
     * toggleBtn.
     * @param {Boolean} flag
     */
    toggleBtn(flag = false) {
      this.showAllBtn?.classList.toggle('hidden', flag);
    }

    /**
     * renderMeta.
     */
    renderMeta() {
      const totalCount = this.querySelectorAll(this.selectors.product).length;
      const isSectionOpened = this.classList.contains(this.classes.opened);

      if (isSectionOpened) {
        this.meta.innerHTML = `Showing ${totalCount} of ${totalCount}`;
        return;
      }

      const difference = this.maxCompareCount - totalCount;
      let currentCount = 0;

      if (difference < 0) {
        // We have more products than we can show
        currentCount = this.maxCompareCount;
      } else {
        // We can show all products
        currentCount = totalCount;
      }

      this.meta.innerHTML = `Showing ${currentCount} of ${totalCount}`;
    }
  }

  customElements.define('variants-group', VariantsGroup);
}
